import { render, staticRenderFns } from "./ProductionListFloating.vue?vue&type=template&id=0dd72c56&scoped=true"
import script from "./ProductionListFloating.vue?vue&type=script&lang=js"
export * from "./ProductionListFloating.vue?vue&type=script&lang=js"
import style0 from "./ProductionListFloating.vue?vue&type=style&index=0&id=0dd72c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd72c56",
  null
  
)

export default component.exports